<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="cover" id="cover">
<img alt="Monsters, Movies &amp;amp; Mayhem" class="cover-image" role="doc-cover" src="images/mmm.jpg"/>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?2b492524